import axios, { getEnv } from '../../../../services/api';
import { useQuery } from 'react-query';
import moment from 'moment';
import {
  AtendimentosPorteProps,
  TotalAtendimentosPorte,
} from '../dashboard.interfaces';
import { formattedPorteSse } from '../models/atendimentosSse.model';
import { TotalFormat } from '../models/acessos.model';

export async function fetchData(filter: string): Promise<any> {
  try {
    // @ts-ignore
    const { data } = await axios.get(
      `${await getEnv('REACT_APP_URL_SERVICE')}/v1/nan/dashboard/${
        filter ? filter : 'total'
      }?dataInicio=2022-11-15&dataFim=2022-12-15`
    );

    return data;
  } catch (error) {
    throw error;
  }
}

const formatPerfilUsuarioAcessos = (data: any) => {
  return data;
};

const formatPorteSse = (data: TotalAtendimentosPorte) => {
  return formattedPorteSse({
    total: data.total,
    atendimentos: data.atendimentos.map(
      (atendimento: AtendimentosPorteProps) => ({
        descricao: atendimento.descricao,
        sigla: atendimento.sigla,
        total: atendimento.total,
      })
    ),
  });
};

const formatTotalSse = (data: any) => {
  return TotalFormat({
    total: {
      name: 'Total de atendimentos SSE',
      data: data.total,
    },
    atendimentos: data.atendimentos.map((atendimento: any) => ({
      data: moment(atendimento.data).format('DD MMM'),
      total: atendimento.total,
    })),
  });
};

async function getDashTotalAtendimentosSSE(filter: string): Promise<any> {
  try {
    const data = await fetchData(filter);

    if (filter === 'perfil-usuario') {
      return formatPerfilUsuarioAcessos(data);
    } else if (filter === 'porte') {
      return formatPorteSse(data);
    } else {
      return formatTotalSse(data);
    }
  } catch (error) {
    throw error;
  }
}

export function useTotalDashAtendimentosSSE(filter: string) {
  return useQuery(
    ['dashTotalAtendSSE', filter],
    () => getDashTotalAtendimentosSSE(filter),
    {
      staleTime: 1000 * 5 * 6, // 5 minutes
    }
  );
}
